import { CircularProgress } from '@mui/material'
import React from 'react'
import './style/donut.scss'

/**
 * 
 * ChartDonut display the length of a process.
 * 
 * ###Import to use it
 *
 *`import { ChartDonut } from '@eco/react-lib'`
 *
 *### Usage
 *
 *`<ChartDonut label={string} value={number}/>`
 *
 *### Basic Example
 */

export const ChartDonut: React.FC<DonutType> = ({ 
        value, 
        label, 
        size = 160, 
        thickness = 4,
        fontSize = 20,
        className
    }: DonutType) => (
    <div className={`chart-donut ${className}`} style={{ width: size }}>
        <CircularProgress variant="determinate" color="primary" thickness={thickness} value={100} size={size} />
        <CircularProgress variant="determinate" className="back" thickness={thickness} value={value} size={size} />
        <span className="indicator" style={{ fontSize: `${fontSize}px` }}>{label}</span>
    </div>
)

export type DonutType = {
    className?: string
    /** Value of the donut */
    value: number
    /** Label to show inside the donut */
    label?: string | React.ReactNode
    /** Size of the donut chart */
    size?: number
    /** Donut thickness */
    thickness?: number
    /** Label font size */
    fontSize?: number
}